import { toast } from 'react-toastify'

import { api } from 'api'
import { Info, Success } from 'constants/actionMessages'
import { PromoPeriod } from 'interfaces/api/promoPeriods.interfaces'
import {
  CreatePromoPeriodParams,
  RemovePromoPeriodParams,
  UpdatePromoPeriodParams,
} from 'interfaces/store/promoPeriods.interfaces'
import { createAction, createAsyncThunk } from 'modules/store'
import { ValidationErrorsApi } from 'packages/api'

export const getAllPromoPeriods = createAsyncThunk('promoPeriods/getAllPromoPeriods', async (_, { rejectWithValue }) =>
  api.promoPeriods.getAll().catch((error) => rejectWithValue(error.message)),
)

export const setPromoPeriodValidationErrors = createAction<ValidationErrorsApi | null>(
  'promoPeriods/setPromoPeriodValidationErrors',
)

export const createPromoPeriod = createAsyncThunk(
  'promoPeriods/createPromoPeriod',
  async (params: CreatePromoPeriodParams, { rejectWithValue, dispatch }) =>
    api.promoPeriods
      .create(params.data)
      .then((data) => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        dispatch(setPromoPeriodValidationErrors(null))
        toast.success(Success.PromoPeriodCreated)
        return data
      })
      .catch((error) => {
        if (error.validation) {
          dispatch(setPromoPeriodValidationErrors(error.validation))
          return
        }
        return rejectWithValue(error.message)
      }),
)

export const updatePromoPeriod = createAsyncThunk(
  'promoPeriods/updatePromoPeriod',
  async (params: UpdatePromoPeriodParams, { rejectWithValue, dispatch }) =>
    api.promoPeriods
      .update(params.id, params.data)
      .then((data) => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        dispatch(setPromoPeriodValidationErrors(null))
        toast.success(Success.Save)
        return data
      })
      .catch((error) => {
        if (error.validation) {
          dispatch(setPromoPeriodValidationErrors(error.validation))
          return
        }
        return rejectWithValue(error.message)
      }),
)

export const removePromoPeriod = createAsyncThunk(
  'promoPeriods/removePromoPeriod',
  async (params: RemovePromoPeriodParams, { rejectWithValue }) =>
    api.promoPeriods
      .remove(params.id)
      .then(() => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        toast.info(Info.PromoPeriodRemoved)
        return
      })
      .catch((error) => rejectWithValue(error.message)),
)

export const setSinglePromoPeriod = createAction<PromoPeriod | null>('promoPeriods/setSinglePromoPeriod')
